<payee-chip-dropdown
  [placeholder]="'Számla azonosító'"
  [selected]="control.value"
  [(dropdownOpen)]="dropdownOpen"
  (removed)="control.patchValue(null)"
>
  <payee-form-field width="wide">
    <span payee-label>Számla azonosító</span>
    <input
      payee-input
      [formControl]="control"
      (paste)="closeAfterPaste()"
    />
  </payee-form-field>
</payee-chip-dropdown>
